import React, { useEffect, useRef } from 'react';
import { useAtom } from 'jotai';
import {
  errorAtom,
  successAtom,
} from '@components/subscription/store/SubscriptionAtoms';
import { Snackbar } from 'geniebook-ui/dist';

const SubscriptionSnackbar = () => {
  const [error, setError] = useAtom(errorAtom);
  const [success, setSuccess] = useAtom(successAtom);
  const showedSnackbar = error ? error : success;
  const state = error ? 'error' : 'celebratory';

  let successTimeout = useRef<ReturnType<typeof setTimeout>>();
  let errorTimeout = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    if (success) {
      clearTimeout(successTimeout.current);
      successTimeout.current = setTimeout(() => {
        setSuccess('');
      }, 5000);
    }
  }, [success]);

  useEffect(() => {
    if (error) {
      clearTimeout(errorTimeout.current);
      errorTimeout.current = setTimeout(() => {
        setError('');
      }, 5000);
    }
  }, [error]);

  const className = 'absolute center-horizontal top-0';

  if (showedSnackbar) {
    if (typeof showedSnackbar === 'string') {
      return (
        <Snackbar
          message={showedSnackbar}
          buttonText={''}
          onTextClick={() => {}}
          states={state}
          className={className}
        />
      );
    } else {
      return <Snackbar {...showedSnackbar} className={className} />;
    }
  }
};

export default SubscriptionSnackbar;
